<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="6"
        offset-md="3"
      >
        <validation-observer ref="forgetLoginIdFormValidator">
          <v-form>
            <v-card>
              <v-card-title>ログインIDの確認</v-card-title>
              <v-card-subtitle>
                パスワードの再設定を行います。<br />
                ログインIDを入力し「確認」ボタンを押して下さい。
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      class="requiredMark"
                      name="ログインID"
                      rules="required"
                    >
                      <v-text-field
                        v-model="loginId"
                        :error-messages="errors"
                        autocomplete="username"
                        label="ログインID"
                        prepend-icon="mdi-email"
                        hide-details="auto"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <template>
                  <p class="red--text text-left">
                    {{ userMessage }}
                  </p>
                </template>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="enableLoginButton"
                  @click="backButtonClickEvent"
                >
                  ログイン画面に戻る
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="toNext"
                >
                  確認
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ForgetLoginIdForm',
  components: {},
  mixins: [],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    enableLoginButton: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      userMessage: null,
      loginId: null,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    ...mapActions('DriverRecovery', {
      indexUser: 'index',
    }),
    backButtonClickEvent () {
      this.$router.replace({ name: 'DriverSessions' })
    },
    toNext () {
      let $self = this
      this.$refs.forgetLoginIdFormValidator.validate().then((result) => {
        if (result) {
          $self.sendToNext()
        }
      })
    },
    sendToNext () {
      this.indexUser({ params: this.loginId }).then((content) => {

        this.user.exists = content.exists
        this.user.login_id = content.login_id
        this.user.email = content.email
        this.user.mobile_number = content.mobile_number

        if (this.user.exists) {
          this.$emit("my-click", this.user);
          this.$emit('toNextStep')
        } else {
          this.userMessage = 'ログインIDが存在しません'
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
